import React from 'react';
import classNames from 'classnames';
import omit from 'omit.js';
import PropTypes from 'prop-types';
import './index.less';

const Icon = (props) => {
	const { type, className = '', spin } = props;
	const classString = classNames({
		ehomeicon: true,
		[`ehomeicon-${type}`]: true,
	}, className);
	return <i {...omit(props, ['type', 'spin']) } className={classString} />;
};

Icon.propTypes = {
	type: PropTypes.string,
	className: PropTypes.string,
	title: PropTypes.string,
	onClick: PropTypes.func
};

export default Icon;
